// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const muk_alola: PokeData = {
  "id": 10113,
  "name": "muk-alola",
  "height": 10,
  "weight": 520,
  "base_experience": 175,
  "types": [
    PokeType.POISON,
    PokeType.DARK
  ],
  "api_moves": [
    "pound",
    "bite",
    "disable",
    "toxic",
    "screech",
    "harden",
    "minimize",
    "haze",
    "poison-gas",
    "acid-armor",
    "sludge-bomb",
    "crunch",
    "memento",
    "knock-off",
    "poison-fang",
    "fling",
    "gunk-shot",
    "acid-spray",
    "belch",
    "moonblast",
    "venom-drench"
  ],
  "moves": [
    "bite",
    "poison-gas",
    "sludge-bomb",
    "crunch",
    "poison-fang",
    "moonblast",
    "venom-drench",
    "toxic-spikes",
    "acid",
    "stun-spore",
    "snatch",
    "snarl",
    "flatter"
  ],
  "evolution_chain": {
    "id": 38,
    "item": null,
    "species": [
      {
        "name": "grimer",
        "order": 96,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "muk",
        "order": 97,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": 88,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 153,
    "speed": 80,
    "ability_power": 167
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "alola"
} as const;
